import { ActionTypes } from '../constants'

const INITIAL_STATE = {
  status: ActionTypes.STATUS.IDLE,
  data: []
}

export default (state = INITIAL_STATE, action) => {
  let target, exists
  switch (action.type) {
    case ActionTypes.LOAD_FILES.SUCCESS:
      return {
        ...state,
        status: ActionTypes.STATUS.SUCCESS,
        data: action.payload.map((a) => {
          target = state.data.find((b) => a.id === b.data.id)
          return {
            status: target ? target.status : ActionTypes.STATUS.IDLE,
            data: {
              ...(target ? target.data : {}),
              ...a
            }
          }
        })
      }
    case ActionTypes.LOAD_FILES.ERROR:
      return { ...state, status: ActionTypes.STATUS.ERROR }
    case ActionTypes.LOAD_FILES.PENDING:
      return { ...state, status: ActionTypes.STATUS.PENDING }
    case ActionTypes.LOAD_FILE.SUCCESS:
      exists = state.data.find((v) => v.data.id === action.payload.id)
      return {
        ...state,
        data: exists
          ? state.data.map((v) =>
              v.data.id === action.payload.id
                ? {
                    status: ActionTypes.STATUS.SUCCESS,
                    data: { ...v.data, ...action.payload }
                  }
                : v
            )
          : [
              { status: ActionTypes.STATUS.SUCCESS, data: action.payload },
              ...state.data
            ]
      }
    case ActionTypes.LOAD_FILE.PENDING:
      return {
        ...state,
        data: state.data.map((v) =>
          v.data.id === action.payload.id
            ? { ...v, status: ActionTypes.STATUS.PENDING }
            : v
        )
      }
    case ActionTypes.LOAD_FILE.ERROR:
      return {
        ...state,
        data: state.data.map((v) =>
          v.data.id === action.payload.id
            ? { ...v, status: ActionTypes.STATUS.ERROR }
            : v
        )
      }
    case ActionTypes.CREATE_FILE.SUCCESS:
      return {
        ...state,
        data: [
          { status: ActionTypes.STATUS.SUCCESS, data: action.payload },
          ...state.data
        ]
      }
    case ActionTypes.CREATE_FILE.ERROR:
      return { ...state }
    case ActionTypes.CREATE_FILE.PENDING:
      return { ...state }
    case ActionTypes.CREATE_FILE_BOOKMARK.SUCCESS:
      return {
        ...state,
        data: state.data.map((v) =>
          v.data.id === action.payload.id
            ? { ...v, data: { ...v.data, bookmarked: true } }
            : v
        )
      }
    case ActionTypes.UPDATE_FILE.SUCCESS:
      return {
        ...state,
        data: state.data.map((v) =>
          v.data.id === action.payload.id
            ? { ...v, data: { ...v.data, ...action.payload } }
            : v
        )
      }
    case ActionTypes.UPLOAD_FILE.SUCCESS:
      if (!action.payload.localId) return { ...state }
      return {
        ...state,
        data: state.data.map((v) =>
          v.data.localId && v.data.localId === action.payload.localId
            ? {
                status: ActionTypes.STATUS.SUCCESS,
                data: { ...v.data, ...action.payload, progress: undefined }
              }
            : v
        )
      }
    case ActionTypes.UPLOAD_FILE.ERROR:
      if (!action.payload.localId) return { ...state }

      return {
        ...state,
        data: state.data.map((v) =>
          v.data.localId === action.payload.localId
            ? { ...v, status: ActionTypes.STATUS.ERROR }
            : v
        )
      }
    case ActionTypes.UPLOAD_FILE.PENDING:
      if (!action.payload.localId) return { ...state }
      exists = state.data.find((v) => v.data.localId === action.payload.localId)
      return {
        ...state,
        data: exists
          ? state.data.map((v) =>
              v.data.localId === action.payload.localId
                ? { ...v, data: { ...v.data, ...action.payload } }
                : v
            )
          : [
              {
                status: ActionTypes.STATUS.PENDING,
                data: { progress: 0, ...action.payload }
              },
              ...state.data
            ]
      }
    case ActionTypes.DELETE_FILE_BOOKMARK.SUCCESS:
      return {
        ...state,
        data: state.data.map((v) =>
          v.data.id === action.payload.id
            ? { ...v, data: { ...v.data, bookmarked: false } }
            : v
        )
      }
    case ActionTypes.DELETE_FILE.SUCCESS:
      return {
        ...state,
        data: state.data.filter((v) => v.data.id !== action.payload.id)
      }
    case ActionTypes.RESET_FILES:
      return { ...INITIAL_STATE }
    default:
      return { ...state }
  }
}
